import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInternalApp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M31.0521 17.7913L19.2782 6.06437L18.489 5.27792C18.3092 5.09991 18.066 5 17.8126 5C17.5591 5 17.3159 5.09991 17.1361 5.27792L4.57298 17.7913C4.38872 17.9742 4.24311 18.192 4.14472 18.4319C4.04633 18.6718 3.99716 18.9289 4.00013 19.1881C4.01231 20.2569 4.90511 21.1102 5.97768 21.1102H7.27269V31H28.3524V21.1102H29.6749C30.1959 21.1102 30.6865 20.9067 31.0552 20.5393C31.2367 20.359 31.3806 20.1445 31.4784 19.9084C31.5762 19.6723 31.626 19.4192 31.625 19.1638C31.625 18.6476 31.4208 18.1587 31.0521 17.7913ZM19.5189 28.8137H16.1062V22.6193H19.5189V28.8137ZM26.1585 18.9239V28.8137H21.4691V21.8905C21.4691 21.2195 20.9236 20.6759 20.2502 20.6759H15.3749C14.7015 20.6759 14.1561 21.2195 14.1561 21.8905V28.8137H9.46659V18.9239H6.54139L17.8156 7.698L18.5195 8.39942L29.0868 18.9239H26.1585Z",
		fill: "black",
		fillOpacity: .85
	})]
});
const ForwardRef = forwardRef(SvgInternalApp);
export { ForwardRef as ReactComponent };
